import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

async function getPhotosAlbum(albumId) {
  const url = `/PhotoAlbum/${albumId}/ListPhotos?thumbnailSize=SMALL`;

  const response = await defaultFetch(url);

  if (response.error) {
    throw new Error('Failed fetch');
  }

  return response;
}

export const getQueryKey = (albumId) => ['photo-album', albumId];

export function usePhotosAlbum({ albumId }) {
  return useQuery({
    queryKey: getQueryKey(albumId),
    queryFn: () => getPhotosAlbum(albumId),
    staleTime: 5 * 60 * 1000, // 5 min
    retry: 2,
    enabled: false
  });
}
